export default "__VITE_ASSET__93f1b42a__"